const data = {
  'Selected': 'انتخاب شده: {0} از {1}',
  'Uploading files': 'در حال آپلود {0}% از {1}',
  'File size error': '{0} حجم فایل زیاد است, لطفا با حجم کمتر از انتخاب نمایید {1}',
  'Upload failed': '{0} آپلود ناموفق',
  'Upload summary': '{0} موفق، {1} ناموفق، {2} مجموع',
  'Per page': '{0} از صفحه',
  'Folder': 'پوشه',
  'Login failed, please try again': 'ورود ناموفق، لطفا مجددا تلاش کنید',
  'Already logged in': 'شما داخل می باشید..',
  'Please enter username and password': 'لطفا نام کاربری و کلمه عبور خود را وارد نمایید.',
  'Not Found': 'پیدا نشد',
  'Not Allowed': 'غیرمجاز',
  'Please log in': 'لطفا وارد شوید',
  'Unknown error': 'پیغام نامشخص',
  'Add files': 'افزودن فایل',
  'New': 'جدید',
  'New name': 'نام جدید',
  'Username': 'نام کاربری',
  'Password': 'کلمه عبور',
  'Login': 'وارد شدن',
  'Logout': 'خارج شدن',
  'Profile': 'پروفایل',
  'No pagination': 'صفحه گذاری نشده',
  'Time': 'زمان',
  'Name': 'نام',
  'Size': 'حجم',
  'Home': 'خانه',
  'Copy': 'کپی',
  'Move': 'انتقال',
  'Rename': 'تغییر نام',
  'Required': 'لطفا این فیلد را کامل نمایید',
  'Zip': 'Zip',
  'Batch Download': 'دانلود گروهی',
  'Unzip': 'Unzip',
  'Delete': 'حذف',
  'Download': 'دانلود',
  'Copy link': 'کپی کردن لینک',
  'Done': 'انجام شد',
  'File': 'فایل',
  'Drop files to upload': 'برای آپلود فایل ها را اینجا رها کنید',
  'Close': 'بستن',
  'Select Folder': 'انتخاب پوشه',
  'Users': 'کاربران',
  'Files': 'فایل ها',
  'Role': 'نقش',
  'Cancel': 'انصراف',
  'Paused': 'متوقف شده',
  'Confirm': 'تائید',
  'Create': 'ایجاد',
  'User': 'کاربر',
  'Admin': 'ادمین',
  'Save': 'ذخیره',
  'Read': 'خواندن',
  'Write': 'نوشتن',
  'Upload': 'آپلود',
  'Permissions': 'دسترسی ها',
  'Homedir': 'پوشه ی اصلی',
  'Leave blank for no change': 'برای تغییر نکردن خالی بماند',
  'Are you sure you want to do this?': 'مطمئن هستید ؟؟',
  'Are you sure you want to allow access to everyone?': 'مطمئنید میخواید همه دسترسی پیدا کنند ؟؟',
  'Are you sure you want to stop all uploads?': 'تمام آپلود ها کنسل شود ؟؟',
  'Something went wrong': 'اشتباهی رخ داده است !',
  'Invalid directory': 'مسیر نادرست',
  'This field is required': 'پر کردن این فیلد اجباریست',
  'Username already taken': 'نام کاربری تکراریست',
  'User not found': 'کاربر پیدا نشد',
  'Old password': 'کلمه عبور قدیمی',
  'New password': 'کلمه عبور جدید',
  'Wrong password': 'کلمه عبور اشتباه است',
  'Updated': 'بروز شد',
  'Deleted': 'حذف شد',
  'Your file is ready': 'فایل شما آماده است.',
  'View': 'نمایش',
  'Search': 'جست و جو',
  'Download permission': 'دانلود',
  'Guest': 'مهمان',
  'Show hidden': 'نمایش مخفی ها',
  'Show symbolic format': 'نمایش قالب نمادین',
  'Hide symbolic format': 'پنهان کردن قالب نمادین',
}

export default data
